import React from 'react';
import {renderElement} from '@Utils/root-element.util';
import {Provider} from 'react-redux';
import type {MergeTagsProps} from '@Components/merge-tags/merge-tags.types';
import MergeTags from '@Components/merge-tags/merge-tags';
import {MergeTagsDropdown} from '@Components/merge-tags/merge-tags-dropdown/merge-tags-dropdown';
import {EmailMakerColorPickerDropdown} from '@Components/email-maker-color-picker-dropdown/email-maker-color-picker-dropdown';
import type {MergeTagsDropdownProps} from '@Components/merge-tags/merge-tags-dropdown/merge-tags-dropdown.types';
import type {EmailMakerColorPickerDropdownProps} from '@Components/email-maker-color-picker-dropdown/email-maker-color-picker-dropdown';
import type {EmailMakerSocialLinkInputSuggestionsProps} from '@Components/email-maker-social-link-suggestions-dropdown/email-maker-social-link-suggestions-dropdown.types';
import {EmailMakerSocialLinkSuggestionsDropdown} from '@Components/email-maker-social-link-suggestions-dropdown/email-maker-social-link-suggestions-dropdown';
import {EmailMakerAiTextPromptBoxDropdown} from '@Components/email-maker-ai-text-prompt-box-dropdown';
import {EmailMakerAiTextPromptBoxDropdownProps} from '@Components/email-maker-ai-text-prompt-box-dropdown/email-maker-ai-text-prompt-box-dropdown';

window.PMW.mergePMW(PMW, {
  initMergeTagsStyles(contentContainer: HTMLElement, mergeTagsProps: MergeTagsProps) {
    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <MergeTags {...mergeTagsProps} />
      </Provider>
    );
  },

  initMergeTagsDropDown(contentContainer: HTMLElement, opts: MergeTagsDropdownProps) {
    if (!contentContainer) {
      return;
    }

    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <MergeTagsDropdown key={opts.listId} {...opts} />
      </Provider>
    );
  },

  renderColorPickerDropdownForText(contentContainer: HTMLElement, opts: EmailMakerColorPickerDropdownProps) {
    if (!contentContainer) {
      return;
    }

    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerColorPickerDropdown {...opts} />
      </Provider>
    );
  },

  initSocialLinksSuggestionsDropdown(contentContainer: HTMLElement, opts: EmailMakerSocialLinkInputSuggestionsProps) {
    if (!contentContainer) {
      return;
    }

    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerSocialLinkSuggestionsDropdown {...opts} />
      </Provider>
    );
  },

  renderAiTextPromptBoxDroptown(contentContainer: HTMLElement, opts: EmailMakerAiTextPromptBoxDropdownProps) {
    if (!contentContainer) {
      return;
    }

    renderElement(
      contentContainer,
      <Provider store={window.PMW.redux.store}>
        <EmailMakerAiTextPromptBoxDropdown {...opts} />
      </Provider>
    );
  },
});

export const initMergeTagsDropdown = (continer: Element, opts: MergeTagsDropdownProps): void => {
  window.PMW.initMergeTagsDropDown(continer, opts);
};

export const renderColorPickerDropdownForText = (contentContainer: HTMLElement, opts: EmailMakerColorPickerDropdownProps): void => {
  window.PMW.renderColorPickerDropdownForText(contentContainer, opts);
};

export const renderMergeTagsComponent = (container: Element, opts: MergeTagsProps): void => {
  window.PMW.initMergeTagsStyles(container, opts);
};

export const initSocialLinksSuggestionsDropdown = (contentContainer: HTMLElement, opts: EmailMakerSocialLinkInputSuggestionsProps): void => {
  window.PMW.initSocialLinksSuggestionsDropdown(contentContainer, opts);
};

export const TOOLBAR_MERGE_TAGS_LIST_ID = 'toolbar-merge-tags-list';
export const RTE_MERGE_TAGS_LIST_ID = 'rte-merge-tags-list';
export const SIDEBAR_MERGE_TAGS_LIST_ID = 'sidebar-merge-tags-list';
